export default __webpack_public_path__ + "static/928-ea350ce18031bd29b065ba0480567e1e.gif";